/* Moodly – lights come on when a scene scrolls into view, reveal on scroll, drag to turn the hero scene, tap a lamp to switch it, product page */
(function () {
  function dragTurn(root) {
    (root || document).querySelectorAll('.mdl-hero__art').forEach(function (a) {
      var w = a.querySelector('.s3--hero .s3__world');
      if (!w || a.hasAttribute('data-drag')) return;
      a.setAttribute('data-drag', '1');
      var rx = 0, ry = 0, sx = 0, sy = 0, bx = 0, by = 0, id = null;
      function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
      a.addEventListener('pointerdown', function (e) {
        if (e.button > 0) return;
        id = e.pointerId; sx = e.clientX; sy = e.clientY; by = ry; bx = rx;
        try { a.setPointerCapture(id); } catch (err) {}
        a.classList.add('is-drag');
      });
      a.addEventListener('pointermove', function (e) {
        if (e.pointerId !== id) return;
        ry = clamp(by + (e.clientX - sx) * 0.25, -40, 40);
        rx = clamp(bx - (e.clientY - sy) * 0.15, -16, 8);
        w.style.setProperty('--dry', ry.toFixed(1) + 'deg');
        w.style.setProperty('--drx', rx.toFixed(1) + 'deg');
      });
      function end(e) { if (e.pointerId !== id) return; id = null; a.classList.remove('is-drag'); }
      a.addEventListener('pointerup', function (e) {
        if (e.pointerId !== id) return;
        if (Math.abs(e.clientX - sx) < 6 && Math.abs(e.clientY - sy) < 6) {
          var hit = document.elementFromPoint(e.clientX, e.clientY);
          var lamp = hit && hit.closest && hit.closest('.hl');
          if (lamp && a.contains(lamp)) lamp.classList.toggle('is-lit');
        }
        end(e);
      });
      a.addEventListener('pointercancel', end);
    });
  }

  function init(root) {
    dragTurn(root);
    var els = (root || document).querySelectorAll('[data-s3], .mdl-rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add(e.hasAttribute('data-s3') ? 'is-on' : 'is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target;
        io.unobserve(t);
        if (t.hasAttribute('data-s3')) {
          setTimeout(function () { t.classList.add('is-on'); }, parseInt(t.getAttribute('data-delay') || '0', 10));
        } else {
          t.classList.add('is-in');
        }
      });
    }, { threshold: 0.3 });
    els.forEach(function (e) { io.observe(e); });
  }

  function productPage(root) {
    (root || document).querySelectorAll('[data-mdl-product]').forEach(function (sec) {
      if (sec.hasAttribute('data-ready')) return;
      sec.setAttribute('data-ready', '1');
      var data = sec.querySelector('[data-variants]');
      var variants = [];
      try { variants = JSON.parse(data ? data.textContent : '[]'); } catch (err) {}
      var form = sec.querySelector('form[data-mdl-form]');
      var track = sec.querySelector('[data-track]');
      var slides = track ? [].slice.call(track.querySelectorAll('[data-media-id]')) : [];
      var thumbs = [].slice.call(sec.querySelectorAll('[data-thumb]'));
      var count = sec.querySelector('[data-count]');

      function show(i, smooth) {
        if (!track || !slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
      function mark(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-current', k === i); });
        if (count) count.textContent = String(i + 1);
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-thumb'), 10), true); }); });
      if (track && slides.length > 1) {
        var raf = 0;
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
        }, { passive: true });
      }
      function showMedia(id) {
        if (!id) return;
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(id)) { show(k, true); mark(k); return; }
        }
      }

      if (!form) return;
      var idInput = form.querySelector('[data-variant-id]');
      var sets = [].slice.call(form.querySelectorAll('[data-opt]'));
      var fixed = [].slice.call(form.querySelectorAll('[data-opt-fixed]'));
      var add = form.querySelector('[data-add]');
      var price = sec.querySelector('[data-price]');
      var compare = sec.querySelector('[data-compare]');

      function selected() {
        var opts = [];
        fixed.forEach(function (f) { opts[parseInt(f.getAttribute('data-opt-fixed'), 10)] = f.value; });
        sets.forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts[parseInt(fs.getAttribute('data-opt'), 10)] = c ? c.value : null;
        });
        return opts;
      }
      function match(opts) {
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k], ok = true;
          for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function anyAvailable(test) {
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k], ok = v.available;
          for (var j = 0; ok && j < test.length; j++) { if (test[j] != null && v.options[j] !== test[j]) ok = false; }
          if (ok) return true;
        }
        return false;
      }
      function markAvailability(opts) {
        // top-down: a value is shown as unavailable only if nothing can be bought with it and the options chosen above it
        sets.forEach(function (fs) {
          var oi = parseInt(fs.getAttribute('data-opt'), 10);
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = [];
            for (var j = 0; j < oi; j++) test[j] = opts[j];
            test[oi] = inp.value;
            inp.closest('.mdl-pill').classList.toggle('is-na', !anyAvailable(test));
          });
        });
      }
      function apply(v) {
        if (!v) {
          if (add) { add.disabled = true; add.textContent = add.getAttribute('data-t-na'); }
          return;
        }
        idInput.value = v.id;
        if (price) price.textContent = v.price;
        if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
        if (add) { add.disabled = !v.available; add.textContent = add.getAttribute(v.available ? 'data-t-add' : 'data-t-sold'); }
        if (v.media) showMedia(v.media);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (err) {}
      }
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.closest || !t.closest('[data-opt]')) return;
        var opts = selected();
        var v = match(opts);
        if (!v) {
          // keep the option the customer just picked, move the others to the first variant that has it
          var oi = parseInt(t.closest('[data-opt]').getAttribute('data-opt'), 10);
          var only = []; only[oi] = t.value;
          v = match(only);
          if (v) {
            sets.forEach(function (fs) {
              var j = parseInt(fs.getAttribute('data-opt'), 10);
              fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === v.options[j]; });
            });
            opts = selected();
          }
        }
        markAvailability(opts);
        apply(v);
      });
      markAvailability(selected());
      var start = null;
      for (var k = 0; k < variants.length; k++) { if (String(variants[k].id) === idInput.value) { start = variants[k]; break; } }
      // open on the first photo; jump to a variant's photo only when the link names a variant
      if (/[?&]variant=/.test(window.location.search) && start && start.media) {
        for (var m = 0; m < slides.length; m++) {
          if (slides[m].getAttribute('data-media-id') === String(start.media)) { show(m, false); mark(m); break; }
        }
      } else if (slides.length) { mark(0); }
      form.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = form.querySelector('input[name=quantity]');
          var n = (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
          q.value = String(Math.max(1, Math.min(99, n)));
        });
      });
    });
  }

  function localizeAnchors(root) {
    var r = window.Shopify && Shopify.routes && Shopify.routes.root;
    if (!r || r === '/') return;
    (root || document).querySelectorAll('a[href^="/#"]').forEach(function (a) { a.setAttribute('href', r + a.getAttribute('href').slice(1)); });
  }

  function start() { localizeAnchors(); init(); productPage(); }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', function (e) { localizeAnchors(e.target); init(e.target); productPage(e.target); });
})();